import { takeLatest, call, all } from "redux-saga/effects";

import { getRoles } from "../../../../services/Roles/sagas";
import { getTenants } from "../../../../services/Tenants/sagas";
import { handlePlatformsWorker } from "../../../../services/Platforms/sagas";

import { initUsersModuleAction } from "./actions";

function* initUsersModuleWorker (){
    yield all([
        call(getRoles),
        call(getTenants),
        call(handlePlatformsWorker)
    ]);
}

export function* initUsers() {
    yield all([
        yield takeLatest(initUsersModuleAction, initUsersModuleWorker)
    ]);
}
